import { useEffect, useState } from 'react';

/**
 * MORNING2: this device's last-known answer to "is the morning chat on for him?" ('true' / 'false'). Written by every
 * Morning read; read before the first `GET /morning` answers, so the rail is held back only for a person last seen
 * switched on. ⛔ Absent or unreadable is OFF - Robert, and a new device, get today's screens while the read is under way.
 * Kept per device: a hint, never a fact.
 *
 * CHAT-DUET (2026-10-28): moved here from `pages/Morning.tsx` so the phone bar (shown only to a switched-on person) can
 * read it on every page; a write is announced (`CHAT_HINT_EVENT`) so a bar already on screen follows a Morning read.
 */
export const CHAT_HINT_KEY = 'apex-morning-chat-on';
export const CHAT_HINT_EVENT = 'apex-morning-chat-hint';

export const readChatHint = (): boolean => {
  try { return localStorage.getItem(CHAT_HINT_KEY) === 'true'; } catch { return false; }
};

export const keepChatHint = (on: boolean): void => {
  try { localStorage.setItem(CHAT_HINT_KEY, String(on)); } catch { /* the hint is simply not kept */ }
  try { window.dispatchEvent(new Event(CHAT_HINT_EVENT)); } catch { /* nothing to tell */ }
};

/** The hint, followed: re-read when a Morning read writes it, or another tab does. */
export function useChatHint(): boolean {
  const [on, setOn] = useState(readChatHint);
  useEffect(() => {
    const again = () => setOn(readChatHint());
    window.addEventListener(CHAT_HINT_EVENT, again);
    window.addEventListener('storage', again);
    return () => {
      window.removeEventListener(CHAT_HINT_EVENT, again);
      window.removeEventListener('storage', again);
    };
  }, []);
  return on;
}
